var jQuery = require('jquery');
import * as ko from 'knockout';

import { formatTime } from '../utils.js';

ko.bindingHandlers.time = 
{
    update: function(element, valueAccessor, allBindingsAccessor) 
    {
        var valueUnwrapped = ko.unwrap( valueAccessor() );
        
        var time_formatted = formatTime(valueUnwrapped/1000, false);

        jQuery(element).html(time_formatted);
    }
};